module.exports = __webpack_public_path__ + "assets_1773307907123/img/pic_5.6228171b.png";